import React from 'react';

import Radium from 'radium';

import ReactTable from 'react-table'

import DateComponent from 'views/DateComponent';
import AppUtil from 'AppUtil';

class RedeemHistoryList extends React.Component {

	render() {
		const redeemHistory = this.props.redeemHistory;

		let columns = [{Header: 'Amount', accessor: 'amount',
							Cell: props => <b>{"Rs. "+AppUtil.formatNumber(props.value)}</b>
						}, 
						{Header: 'Withdraw State', accessor: 'state'},
						{Header: 'Withdraw Requested On', accessor: 'createdDate',
							Cell: props => <DateComponent date={props.value} />
						},
						{Header: 'Withdrawn On', accessor: 'redeemedDate',
							Cell: props => props.value? <DateComponent date={props.value} />: "-"
						}
					];

		const showLoading = redeemHistory? false: true;

		const style = [];

		if(this.props.style)
			style.push(this.props.style);

		return <div style={style}>
			<h2><u>Withdrawal History</u></h2>
			
			<ReactTable data={redeemHistory? redeemHistory.toArray(): []} columns={columns} minRows={5} 
						noDataText="You have no withdrawal history." loading={showLoading} />
		</div>
	}

}


export default Radium(RedeemHistoryList);


// WEBPACK FOOTER //
// ./src/views/designer/RedeemHistoryList.js